import PanelComponent from './Panel.vue';
import TaskPanelComponent from './TaskPanel.vue';
import JobPanelComponent from './JobPanel.vue';
import CustomerTabComponent from './CustomerTab.vue';
import UserChatComponent from './UserChat.vue';
import ImageModalComponent from './ImageModal.vue';
import ModChatComponent from './ModChat.vue';
import RatingComponent from './Rating.vue';
import PaginatorComponent from './Paginator.vue';
import TaskShowComponent from './TaskShow.vue';
import JobChatComponent from './JobChat.vue';
import TaskChatComponent from './TaskChat.vue';
import ImageBarComponent from './ImageBar.vue';
import CustomerRatingComponent from './CustomerRating.vue';

const Panel = {
  install(Vue) {
    Vue.component(PanelComponent.name, PanelComponent);
    Vue.component(TaskPanelComponent.name, TaskPanelComponent);
    Vue.component(JobPanelComponent.name, JobPanelComponent);
    Vue.component(CustomerTabComponent.name, CustomerTabComponent);
    Vue.component(UserChatComponent.name, UserChatComponent);
    Vue.component(ImageModalComponent.name, ImageModalComponent);
    Vue.component(ModChatComponent.name, ModChatComponent);
    Vue.component(RatingComponent.name, RatingComponent);
    Vue.component(PaginatorComponent.name, PaginatorComponent);
    Vue.component(TaskShowComponent.name, TaskShowComponent);
    Vue.component(JobChatComponent.name, JobChatComponent);
    Vue.component(TaskChatComponent.name, TaskChatComponent);
    Vue.component(ImageBarComponent.name, ImageBarComponent);
    Vue.component(CustomerRatingComponent.name, CustomerRatingComponent);
  },
};

export default Panel;
